import { PageIcon } from "@/components/PageIcon";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { AlarmClock } from "lucide-react";

const gbp = (v) => `£${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function OverdueInvoicesPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/invoices/overdue").then((r) => setData(r.data)).catch(() => setData({ items: [], summary: { count: 0, owed: 0 } })); }, []);

  return (
    <div className="px-4 sm:px-8 pt-3 sm:pt-4 pb-6 sm:pb-8" data-testid="overdue-invoices-page">
      <div className="flex items-center gap-3 mb-4">
        <PageIcon />
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Overdue invoices</h1>
          <p className="text-sm text-slate-500" data-testid="overdue-summary">
            {data ? `${data.summary.count} unpaid past due date · ${gbp(data.summary.owed)} owed` : "Loading…"}
          </p>
        </div>
      </div>
      <div className="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[900px]">
          <thead className="bg-slate-50 text-[11px] uppercase tracking-wide text-slate-500">
            <tr>{["Invoice", "Job", "Customer", "Due date", "Days overdue", "Total", "Paid", "Owed"].map((h, i) => <th key={h} className={`py-2.5 px-3 font-semibold ${i >= 4 ? "text-right" : "text-left"}`}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {(data?.items || []).map((r) => (
              <tr key={`${r.job_legacy_id}-${r.invoice_id}`} className="border-b border-slate-100" data-testid={`overdue-row-${r.invoice_id}`}>
                <td className="py-2.5 px-3 font-mono font-semibold text-slate-800">{r.invoice_no}</td>
                <td className="py-2.5 px-3"><Link to={`/tasks/${r.job_legacy_id}`} className="font-semibold text-indigo-600 hover:underline">{r.job_legacy_id}</Link>
                  {r.job_title && <div className="text-[11px] text-slate-500">{r.job_title}</div>}</td>
                <td className="py-2.5 px-3">{r.customer || "—"}</td>
                <td className="py-2.5 px-3 whitespace-nowrap">{r.due_date}</td>
                <td className={`py-2.5 px-3 text-right font-semibold ${r.days_overdue > 30 ? "text-rose-600" : "text-amber-600"}`}>{r.days_overdue}</td>
                <td className="py-2.5 px-3 text-right tabular-nums">{gbp(r.total)}</td>
                <td className="py-2.5 px-3 text-right tabular-nums text-emerald-600">{gbp(r.amount_paid)}</td>
                <td className="py-2.5 px-3 text-right tabular-nums font-bold text-rose-600" data-testid={`overdue-owed-${r.invoice_id}`}>{gbp(r.balance)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {data && data.items.length === 0 && <p className="p-6 text-center text-sm text-slate-500" data-testid="overdue-empty">No overdue invoices.</p>}
      </div>
    </div>
  );
}
